import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL, formatPattern } from '../../utils';

export const onSwitchListIsLoading = isLoading => ({
    type: CONSTANTS.ON_SWITCH_LIST_IS_LOADING,
    payload: { isLoading }
});

export const onSwitchList = data => ({
    type: CONSTANTS.ON_SWITCH_LIST,
    payload: { data }
});

const onRelayTypesIsLoading = isLoading => ({
    type: CONSTANTS.ON_RELAY_TYPES_IS_LOADING,
    payload: { isLoading }
});

const onRelayTypes = data => ({
    type: CONSTANTS.ON_RELAY_TYPES,
    payload: { data }
});

export const onSelectSwitch = swId => ({
    type: CONSTANTS.ON_SELECT_SWITCH,
    payload: { swId }
});

export const onEditRelay = relay => ({
    type: CONSTANTS.ON_EDIT_RELAY,
    payload: { relay }
});

export const patchRelay = (meterId, switchId, relayId, values, callback = null) => ({
    type: CONSTANTS.ON_PATCH_RELAY,
    payload: { meterId, switchId, relayId, values, callback }
});

export const saveSwitch = (homeId, meterId, switc, callback = null) => ({
    type: CONSTANTS.ON_SAVE_SWITCH,
    payload: { homeId, meterId, switc, callback }
});

export const patchSwitch = (meterId, switchId, values, callback = null) => ({
    type: CONSTANTS.ON_PATCH_SWITCH,
    payload: { meterId, switchId, values, callback }
});

const onDeletedSwitch = data => ({
    type: CONSTANTS.ON_DELETED_SWITCH,
    payload: { data }
});

export const onDeleteSwitch = (switchId) => (dispatch) =>
    api(formatPattern(REQUEST_URL.SWITCH_POST, { switchId }), METHOD.DELETE);

export const onUndeleteSwitch = (switchId) => (dispatch) =>
    api(formatPattern(REQUEST_URL.SWITCH_UNDELETE_ID, { switchId }), METHOD.PUT)
        .then(dispatch(onDeletedSwitch(false)));

// ========= THUNKS ============

/**
 * fetchAllSwitches
 * - Fetching all device types
 * @since 2.12.4
 *
 *
 * @returns {Promise}
 */
export const fetchAllSwitches = meterId => (dispatch, getState) => {

    dispatch(onSwitchList(fromJS([])));
    dispatch(onSwitchListIsLoading(true));

    return api(formatPattern(REQUEST_URL.SWITCH_LIST, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onSwitchList(fromJS(res.body)));
                dispatch(onSwitchListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onSwitchListIsLoading(false));
            throw err;
        });
};

export const fetchRelayTypes = switchType => (dispatch) => {

    dispatch(onRelayTypes(fromJS([])));
    dispatch(onRelayTypesIsLoading(true));

    return api(`${formatPattern(REQUEST_URL.SWITCH_RELAY_TYPES, {switchType})}?switchType=${switchType.join(",")}`, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onRelayTypes(res.body));
                dispatch(onRelayTypesIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onRelayTypesIsLoading(false));
            throw err;
        });
};

export const fetchSwitchConnectionStatus = (meterId, callback) =>
    api(formatPattern(REQUEST_URL.SWITCH_STATUS, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                if(callback) callback(res.body);
            }
        })
        .catch(err => {
            if(callback) callback();
            throw err;
        });
